import { isNil, isNot } from 'remeda';
var notNil = isNot(isNil);
export default notNil;
